
const angular = require('angular');

function ScrollIfDirective () {
    return function (scope, element, attributes) {
        scope.$watch(attributes['scrollIf'], () => {
            const result = scope.$eval(attributes.scrollIf);
            if (result) {
                element[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        });
    };
}

export default angular
    .module('spsng.components.scroll-if', [])
    .directive('scrollIf', ScrollIfDirective)
    .name;
